/**
 * track-info.js
 */

import React from 'react';
import { 
  Box,
  Tooltip,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { DISTANCE_UNIT_NAME, convertDistance } from 'utils/distance';
import { formatSecondsAsTime } from 'utils/datetime';
import InfoRow from 'components/info-row/info-row';
import { TRACK_TYPE, TRACK_TYPE_LABEL } from '../tracking-common';


export default function TrackInfo(props) {
  const { track, trackRecord, checkBoxProps } = props;
  const device = track?.device;


  const getTrackNameLabel = () => {
    if (track.type === TRACK_TYPE.DEPLOYMENT) {
      return 'Case';
    } else if (track.type === TRACK_TYPE.LEAD) {
      return 'Track Name';
    } else if (track.type === TRACK_TYPE.FOLLOW) {
      return 'Exercise Name';
    }
  }
 
  
  const getTrackName = () => {
    if (track.type === TRACK_TYPE.DEPLOYMENT) {
      return trackRecord?.caseNumber ?? 'n/a';
    } else if (track.type === TRACK_TYPE.LEAD) {
      return track.name;
    } else if (track.type === TRACK_TYPE.FOLLOW) {
      return trackRecord?.exercise?.name ?? 'n/a';
    }
  }


  return (
    <Box sx={{ mb: 2, display: 'inherit', flexDirection: 'inherit' }}>
      <FormControlLabel
        sx={{ ml: checkBoxProps ? -0.6 : 0, mb: 0.5, height: 32 }}
        label={`${TRACK_TYPE_LABEL[track.type]}`}
        control={checkBoxProps
          ? <Checkbox checked={checkBoxProps.checked} onChange={e => checkBoxProps.onChange(e.target.checked)} />
          : <></>
        }
      />

      <InfoRow title={getTrackNameLabel()} text={getTrackName()} />
      <InfoRow title='Handler' text={track.userName} />
      {track.type === TRACK_TYPE.FOLLOW &&
      <InfoRow title='Dog' text={trackRecord?.completion?.dog?.name ?? 'n/a'} />}
      <InfoRow title='Points' text={track.points.length} />
      <InfoRow title='Distance' text={`${convertDistance(track.distance, DISTANCE_UNIT_NAME.METERS, DISTANCE_UNIT_NAME.YARDS)} yards`} />
      <InfoRow title='Duration' text={`${formatSecondsAsTime(track.duration)}`} />
      <InfoRow title='Is complete' text={track.isComplete ? 'Yes' : 'No'} />
      <Tooltip arrow placement='top' title={device.uniqueId}>
        <span><InfoRow title='Phone' text={`${device.brand} ${device.model}`} /></span>
      </Tooltip>
      <InfoRow title='Software' text={`${device.platform}, App: ${device.appVersion}`} />
      <InfoRow title='Background tracking' text={device.canBackgroundTrack ? 'Yes' : 'No'} />
    </Box>
  );
}